export const DOCTOR = {
  name: "Dr. Chandrani Jha",
  title: "Consultant Gynaecologist & Obstetrician",
  qualifications: "MBBS (Hons), D.G.O. (Medical College, Kolkata), D.N.B.",
  languages: ["Bengali", "Hindi", "English", "Maithili"],
  tagline: "Compassionate Care. Healthy Women. Stronger Families.",
  phones: ["+91 98366 92288", "+91 70011 80969", "+91 97341 31225"],
  email: "chandranijha10@drchandranijha.com",
  portrait: "https://customer-assets.emergentagent.com/job_medical-practice-hub-6/artifacts/ii40l4qf_WhatsApp%20Image%202026-06-28%20at%203.12.40%20PM.jpeg",
  mapsLink: "https://maps.app.goo.gl/ufAS6kpEf2GMTKP88",
};

export const CLINICS = [
  {
    id: "ganesh",
    name: "Ganesh Medical",
    address: "Birpara, Alipurduar, West Bengal 735204",
    hours: "Mon – Sun · 12 PM – 4 PM",
    closed: "Thursday closed",
    phone: "+91 70011 80969",
    mapsLink: "https://maps.app.goo.gl/ufAS6kpEf2GMTKP88",
  },
  {
    id: "daynight",
    name: "Day Night Medical",
    address: "Birpara, Alipurduar, West Bengal 735204",
    hours: "Tue – Sun · 12 PM – 4 PM",
    closed: "Monday closed",
    phone: "+91 97341 31225",
    mapsLink: "https://maps.app.goo.gl/ufAS6kpEf2GMTKP88",
  },
];

export const SERVICES = [
  { title: "Antenatal Care", desc: "Personalised pregnancy care from confirmation through delivery, with regular monitoring and reassurance at every step." },
  { title: "High-Risk Pregnancy", desc: "Specialised oversight for complex pregnancies, with close coordination and 24×7 nursing-home support." },
  { title: "Postnatal Care", desc: "Recovery, breastfeeding support, and emotional well-being for new mothers in the tender fourth trimester." },
  { title: "Infertility Consultation", desc: "Compassionate first conversations, evaluation of both partners, and a clear plan forward." },
  { title: "Gynaecological Surgeries", desc: "Routine and advanced procedures performed with care, precision, and follow-through." },
  { title: "Menstrual Disorders", desc: "Heavy bleeding, painful or irregular cycles, PCOS — examined and treated, not silently endured." },
  { title: "Menopause Care", desc: "Symptom management, bone and heart health, and a kind ear for life's second spring." },
  { title: "Family Planning", desc: "Counselling and contraception options tailored to your life stage and personal preferences." },
  { title: "Ultrasound & Diagnostics", desc: "In-clinic scans and prompt diagnostic guidance to keep your care moving forward." },
];

export const FAQS = [
  { q: "Do I need to book an appointment in advance?", a: "Walk-ins are welcome during clinic hours, but booking in advance ensures a shorter wait and dedicated time. Use the booking form or call us directly." },
  { q: "Which clinic should I visit?", a: "Both clinics in Birpara, Alipurduar offer the same standard of care. Day Night Medical is attached to Maa Nursing Home (24×7) for cases needing extended care." },
  { q: "What should I bring for my first visit?", a: "Any previous prescriptions, scan reports, blood reports, and a list of current medications. Don't worry if you don't have everything — we'll guide you." },
  { q: "Is care available in Bengali, Hindi or Maithili?", a: "Yes. Dr. Chandrani Jha consults fluently in Bengali, Hindi, English, and Maithili." },
  { q: "Do you handle emergencies?", a: "For obstetric or gynaecological emergencies, please call the clinic numbers immediately. After-hours support is available through Maa Nursing Home." },
];
